import { Alert, styled } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export const StyledAlertReport = styled(Alert)(() => ({
  backgroundColor: NEW_COLORS.SEMANTICS.WARNING[25],
  borderRadius: '8px',
  padding: '16px 12px',
  '& .MuiAlert-icon': {
    color: NEW_COLORS.GRAYSCALE[800],
    display: 'flex',
    alignItems: 'center',
  },
}));
